module.exports = __webpack_public_path__ + "static/media/fk.d1f6fed1.svg";